import { Component, OnInit } from "@angular/core";
import { Globals } from "../../globals";
import { ConflictosService } from "../servicios/conflictos.service";
import Swal from "sweetalert2";

@Component({
  selector: "app-nuevo-conflicto",
  templateUrl: "./nuevo-conflicto.component.html",
  styleUrls: ["./nuevo-conflicto.component.css"]
})
export class NuevoConflictoComponent implements OnInit {
  tipoPregunta;
  tituloNuevoConflicto;
  tiposConflicto = [];

  constructor(
    public global: Globals,
    private conflictosService: ConflictosService
  ) {}

  ngOnInit() {
    this.global.conflictosEditarConflicto = false;

    if (this.global.lenguaje == "es") {
      this.tituloNuevoConflicto = "Lista de tipos de conflictos";
    } else {
      this.tituloNuevoConflicto = "List of conflict types";
    }

    let etiquetaCargando = { es: "Cargando", en: "Loading" };
    Swal.fire(etiquetaCargando[this.global.lenguaje]);
    Swal.showLoading();

    this.conflictosService
      .consultarNumeroConflictosPorPregunta(
        this.global.IdFuncionarioTablaFuncionarios
      )
      .subscribe(datos => {
        Swal.close();
        //////conole.log(datos);
        let preguntas = <any[]>datos;
        for (let i = 0; i < preguntas.length; i++) {
          const pregunta = preguntas[i];
          let conflicto = { tipo: pregunta["tipo"] };
          conflicto["titulo"] = pregunta[this.global.lenguaje];
          conflicto["cantidad"] = pregunta["cantidad"];
          this.tiposConflicto.push(conflicto);
        }
      });
  }

  seleccionarPregunta(objetoTipo) {
    this.tipoPregunta = objetoTipo.tipo;
    this.global.conflictosPreguntaGlobal = true;
  }
}
